import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { SxProps } from '@mui/material'
interface ITrayIconProps {
  sx?: SxProps
}

const TrayIcon = ({sx={}}:ITrayIconProps): JSX.Element => <DeleteOutlinedIcon sx={sx}/>;

export default TrayIcon;
